import { render } from "./WithdrawConfirmationForm.vue?vue&type=template&id=56a55a91&scoped=true"
import script from "./WithdrawConfirmationForm.vue?vue&type=script&lang=js"
export * from "./WithdrawConfirmationForm.vue?vue&type=script&lang=js"

import "./WithdrawConfirmationForm.vue?vue&type=style&index=0&id=56a55a91&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a55a91"]])

export default __exports__